import React, { useCallback } from 'react'
import { useApolloClient } from '@apollo/client/react'
import { TOWING_JOBS_OPEN_QUERY, OpenTowingJob } from './queries'
import { isActiveJob } from '../../containers/TowingJobsPage/countJobs'
import { useTowingJobsListChange } from '../../containers/TowingJobsPage/towingJobsWatcher'

export const countJobs = (orders: OpenTowingJob[]): number =>
  orders.reduce((noOfOpenJobs, currentOrder) => {
    if (isActiveJob(currentOrder.status, currentOrder.operatorId)) {
      return noOfOpenJobs + 1
    }
    return noOfOpenJobs
  }, 0)

export const OpenJobCountWatcher: React.FC = () => {
  const client = useApolloClient()
  const callback = useCallback(()=>{
    setTimeout(() => {
      client.refetchQueries({
        include: [TOWING_JOBS_OPEN_QUERY]
      })
    }, 5000)
  }, [client])

  useTowingJobsListChange(callback)

  return null
}
